export default "/assets/images/CC-product-with-box.657a59fb67fb5e05.webp";